import { Products } from './Products';
import { ProductsProvider } from './productsContext/products.context';

export default () => (
  <ProductsProvider>
    <Products />
  </ProductsProvider>
);
